import { createAction, props } from "@ngrx/store";

export const fetchPayments = createAction(
  "[Payment] Fetch",
  props<{ page, filterOptions }>()
);

export const fetchPaymentsSuccess = createAction(
  "[Payment] Fetch Success",
  props<{ payments }>()
);

export const fetchPaymentsFailure = createAction(
  "[Payment] Fetch Faild",
  props<{ error }>()
);

export const getPayment = createAction(
  "[Payment] Get",
  props<{ paymentID }>()
);

export const getPaymentSuccess = createAction(
  "[Payment] Get Success",
  props<{ payment }>()
);

export const getPaymentFailure = createAction(
  "[Payment] Get Faild",
  props<{ error }>()
);